export const getOAuthHeaders = () => {
    const rawCookie = document.cookie;
    const cookies = rawCookie.split('; ');
    let access_token;
    let email;
    let username;
    let Enterprise;
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].split('=');
        const name = cookie[0];
        const value = cookie[1];
        if (name.includes('accessToken')) {
            access_token = value;
        }
        if (name.includes('LastAuthUser')) {
            email = decodeURIComponent(value);
        }
        if (name === "username") {
            username = value;
        }
        if (name === "Enterprise") {
            Enterprise = value;
        }
    }

    const cookieNames = cookies.map((c) => c.split('=')[0]).filter(Boolean);
    // console.debug("[AUTH-DIAG] getOAuthHeaders", {
    //     cookieCount: cookies.length,
    //     cookieNames,
    //     rawCookieLength: rawCookie.length,
    //     hasAccessToken: !!access_token,
    //     hasEmail: !!email,
    //     hasUsername: !!username,
    //     hasEnterprise: !!Enterprise,
    //     hostname: window.location.hostname,
    //     protocol: window.location.protocol,
    //     pathname: window.location.pathname,
    //     isElectron: !!window.electronAPI,
    // });

    // Return headers if access token exists, regardless of expiry.
    // Response interceptors handle 401 → refresh → retry.
    if (access_token) {
        return {
            access_token: `bearer ${access_token}`,
            email: email,
            Enterprise: Enterprise,
            username: username,
        };
    }

    // No access token — truly unauthenticated
    //console.warn("[AUTH-DIAG] No access token found. Raw cookie string:", rawCookie.substring(0, 200));
    return undefined;
};
